import React from "react";
import { withTranslation } from "react-i18next";
import BCEnvironmentalActivityBase from "./bcEnvironmentalActivityBase";
import BCEnvironmentalRetirementsTable from "./bcEnvironmentalRetirementsTable";
import { getRetirements } from "../../common/services/marketdata/bcEnvironmentalService";

const BCEnvironmentalRetirements = ({ t }) => (
  <BCEnvironmentalActivityBase
    t={t}
    titleKey="BCEnvironmentalRetirements"
    retrievedCountKey="RetrievedBCEnvironmentalRetirements"
    chartTitle="Retirement Quantities by Day"
    downloadFileName="BCEnvironmentalRetirements.xlsx"
    fetchData={getRetirements}
    dateField="retiredDate"
    searchFields={[
      "accountName",
      "beneficialOwner",
      "projectName",
      "location",
      "serialNo",
    ]}
    TableComponent={BCEnvironmentalRetirementsTable}
    exportMapper={(record, formatDateValue) => ({
      RetiredDate: formatDateValue(record.retiredDate),
      AccountName: record.accountName,
      BeneficialOwner: record.beneficialOwner,
      BeneficiaryLocation: record.beneficiaryLocation,
      ProjectName: record.projectName,
      Location: record.location,
      Quantity: record.holdingQuantity,
      StandardName: record.standardName,
      Vintage: record.vintage,
      ProjectType: record.projectType,
      MonitoringPeriodStart: formatDateValue(record.monitoringPeriodStart),
      MonitoringPeriodEnd: formatDateValue(record.monitoringPeriodEnd),
      ActionPurpose: record.actionPurpose,
      RetirementRemarks: record.retirementRemarks,
      VerifierCompany: record.verifierName,
      SerialNo: record.serialNo,
      UnitType: record.unitType,
      UnitMeasurementName: record.unitMeasurementName,
    })}
  />
);

export default withTranslation(["marketdata"])(BCEnvironmentalRetirements);
